import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateTransactionDraftReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchCreateTransactionDraft(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateTransactionDraftAttempt', handleCreateTransactionDraft, api);
}

function* handleCreateTransactionDraft(api: GoldGateway, action: PayloadAction<TCreateTransactionDraftReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.createTransactionDraft], { authToken, ...action.payload });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateTransactionDraftFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldCreateTransactionDraftSuccess(response.data));
    }
}
